module.exports = __webpack_public_path__ + "media/src/images/dandori/step2-1001bafa43b8da071c7f10eb4e64072b.png";